var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex","gutter":20}},[_vm._v(" Вывести стату, обсудить, что, куда и как ")])}
var staticRenderFns = []

export { render, staticRenderFns }